import angular from "angular";
import "angular-ui-carousel/dist/ui-carousel";
import "angular-ui-carousel/dist/ui-carousel.css";

export default angular.module("vui-carousel", ["ui.carousel"]);
